import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = ['getAddressTypeFinish'];

const getAddressTypeFinish = async () => {
  return await request.get(
    '/HousingStock/address_type_finish',
    null,
    'При получении видов отделки произошла ошибка'
  );
};

const useAddressTypeFinishQuery = (options) =>
  useQuery(key, getAddressTypeFinish, options);

export default useAddressTypeFinishQuery;
